import { NavLink, Outlet } from 'react-router-dom';
import { MODULES } from '../../lib/modules.js';
import { canSeeSubscreen, canEdit, useRole } from '../../lib/role.tsx';

export function OrdersLanding() {
  const role = useRole();

  const ordersMod = MODULES.find((m) => m.slug === 'orders')!;
  const visibleTabs = ordersMod.subscreens!.filter((sub) => canSeeSubscreen(role, sub));
  const readonly = !canEdit(role, ordersMod);

  return (
    <div className="flex flex-col h-full">
      {readonly && (
        <div
          data-testid="orders-readonly-badge"
          className="flex items-center gap-2 px-4 py-1 bg-amber-50 border-b border-amber-200 text-amber-700 text-xs"
        >
          <span>Режим просмотра — редактирование недоступно</span>
        </div>
      )}
      <nav className="flex border-b border-gray-200 bg-white">
        {visibleTabs.map((sub) => (
          <NavLink
            key={sub.id}
            to={`/m/orders/${sub.slug}`}
            data-testid={`orders-tab-${sub.slug}`}
            className={({ isActive }) =>
              `px-4 py-2 text-sm font-medium border-b-2 transition-colors ${
                isActive
                  ? 'text-mnp-stamp border-mnp-stamp'
                  : 'text-gray-600 border-transparent hover:text-mnp-stamp hover:border-mnp-stamp'
              }`
            }
          >
            {sub.label}
          </NavLink>
        ))}
      </nav>
      <div className="flex-1 overflow-auto">
        <Outlet />
      </div>
    </div>
  );
}
